import { useEffect, useRef } from 'react';
import FaqItem from 'slickpay/online/FaqItem.component';

import { QUESTIONS } from 'constants/stripeCapital/stripeCapitalQuestions.const';
import { useTranslation } from 'providers/GILT.provider';

import CN from './StripeCapitalFaq.module.scss';

const QUESTION_KEYS = Object.values(QUESTIONS);

const INCREASE_CHANCES_ITEMS = ['historyMonths', 'volume', 'standing', 'growth'];

export const StripeCapitalFaq = ({ isDark = false, openQuestionKey, scrollTrigger }) => {
  const { t } = useTranslation();
  const questionRefs = useRef({});

  const renderDescription = (key) => {
    if (key === QUESTIONS.increaseChances) {
      return (
        <div className={CN.description}>
          <p>{t('stripeCapitalFaq.questions.increaseChances.intro')}</p>
          <ul>
            {INCREASE_CHANCES_ITEMS.map((id) => (
              <li key={id}>{t(`stripeCapitalFaq.questions.increaseChances.items.${id}`)}</li>
            ))}
          </ul>
          <p>{t('stripeCapitalFaq.questions.increaseChances.outro')}</p>
        </div>
      );
    }

    return <div className={CN.description}>{t(`stripeCapitalFaq.questions.${key}.description`)}</div>;
  };

  useEffect(() => {
    if (!openQuestionKey) return;

    const target = questionRefs.current[openQuestionKey];
    target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [openQuestionKey, scrollTrigger]);

  return (
    <div data-bem="StripeCapitalFaq" className={CN.component}>
      <div className={CN.title}>{t('stripeCapitalFaq.title')}</div>

      <div className={CN.container} data-bem="FaqTips__container">
        {QUESTION_KEYS.map((key) => (
          <div
            key={key}
            ref={(el) => {
              if (el) {
                questionRefs.current[key] = el;
              }
            }}
          >
            <FaqItem
              title={t(`stripeCapitalFaq.questions.${key}.title`)}
              description={renderDescription(key)}
              variant="full"
              isDark={isDark}
              isOpen={openQuestionKey === key}
              scrollTrigger={scrollTrigger}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
